module.exports = __webpack_public_path__ + "img/option3.4a5e932a.webp";